import styled, { css } from 'styled-components';

export const ErrorText = styled.div<{
  $error?: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.primary} !important;
  visibility: ${({ $error }) => ($error ? 'visible' : 'hidden')};
  font-weight: 300;
  font-size: 12px;
  top: 7px;

  p {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 300;
    font-size: 12px;
    word-break: break-word;
  }

  svg {
    position: relative;
    top: -1px;
    margin-right: 8px;
  }
`;

export const FormLabel = styled.label<{ $active: boolean; $error?: boolean }>`
  color: ${({ theme, $error }) =>
    $error ? theme.colors.lightRed : theme.colors.darkBlue};
  font-size: ${({ $active: active }) => (active ? '12px' : '16px')};
  line-height: 18px;
  font-weight: 400;
  position: absolute;
  transition: 0.5s;
  top: ${({ $active }) => ($active ? '2px' : '21px')};
  left: 0;
  cursor: ${({ $active }) => ($active ? 'default' : 'text')};
`;

export const InputContainer = styled.div<{
  $error?: boolean;
  $disabled?: boolean;
}>`
  position: relative;
  height: 53px;
  margin-bottom: 32px;
  border-bottom: 2px solid
    ${({ $error, theme }) =>
      $error ? theme.colors.lightRed : theme.colors.darkBlueV2};
  box-sizing: border-box;
  width: 100%;
  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.4;
      user-select: text;
      pointer-events: none;
    `};

  @media (height <= 750px) {
    margin-top: 25px;
  }
`;
